<template>
   
        <div class="col-md-6 col-lg-4" v-if="new_data.length>0" >
			<div class="blog-entry animate-box" @mouseover="newShow=true" @mouseleave="newShow=false" >
                
				<div class="blog-img" :style="'background-image: url('+CONTENT_DOMAIN+'/img/helpwhereyouare_site/ThemeMegazine/homepage/cards/new_placeholder.jpg);'" >
					<div class="desc text-center side">
						<p class="tag"><!--<span>Interactive</span>--></p>
						<h2 tabindex="0" v-on:focus="newShow=true" :class="{'head-article':true, 'home-tile-head':(newShow===false)}" v-html="languageData['new']"></h2>
                        <transition name="slide-fade">                      
                            <p v-if="newShow" class="content-height"> 
                                <ul class="category">
                                    <li v-for="(new_content,kye) in new_data " :key=kye>
                                        <router-link :to="'/content/'+new_content['id_cr']+'?e='+new_content['id_element']" v-html="new_content['title']"></router-link>
                                    </li>                                
                                </ul>                                
                            </p>                            
                        </transition>
                        <br/>
					</div>
				</div>
			</div>
		</div>

</template>

<script>
import {CONTENT_DOMAIN} from '@/constants/general_constants';
import axios from 'axios';
 
export default {
    name: 'NewDetails',
    data() {
        return {
            new_data: [],
            newShow:false,
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN
           
        };
                
    },
    computed:{
        languageData(){return this.$store.state.languageData;}
    },
    components: {
           
        },
    created :function(){        
        this.showNewContent()      
    },
    methods:{
        showNewContent(){ 
            var api_private_key=this.get_api_key_mix('nels')
            axios.get(this.$store.state.apiUrl+'/new_details',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    id_company:this.$store.state.companyData['id_company'],
                    id_service:this.$store.state.companyData['id_service_actual'],
                    privatekey:api_private_key
                    
                }
            })
            .then(response => {
                response = response.data
                //console.log(response);
                this.new_data = response;
                this.$nextTick(function () {
                    
                })
            
            })
            .catch((error) => {
                this.new_data = [];
                this.customErrorHandler(error.response.status);
            });
        }    

    }
}
</script>
<style scoped>
.blog-entry .desc {
    background: #2f2f2fcc !important;
}
.blog-entry .side{
    margin-bottom: 0;
}
.category li a {
    border-bottom: 1px solid #c5c5c599 !important;
    display: block;
    padding: 5px 0;
    color: #e6e6e6 !important;   
}
.category li {
    list-style: none !important;
}
.head-article{
    color: #fff !important;
}
.btn-style{
    display: inline-block;
    bordeR: 1px solid rgba(255, 255, 255, 0.5);
    padding: 3px 11px;
    -webkit-border-radius: 16px;
    -moz-border-radius: 16px;
    -ms-border-radius: 16px;
    border-radius: 16px;
    color: #fcfcfc;
    background: #505050ed;
    font-size: 12px;
}
.btn-style:hover{
    border: 1px solid rgba(255, 255, 255, 0.82);
    color: #fff;
}
.category li a:hover,.category li a:focus {
    color: #fff !important;
}

.content-height{
    overflow: auto !important;
    max-height: 355px !important;
}
@media only screen and (max-width: 768px) {
    .content-height{
        max-height: 255px !important;
    }
}
    
</style>